module.exports = __webpack_public_path__ + "img/activation_server_mp.a7fc9cda.svg";